import { render, staticRenderFns } from "./CarNumberBlock.vue?vue&type=template&id=cfa76d9a&scoped=true"
import script from "./CarNumberBlock.vue?vue&type=script&lang=ts"
export * from "./CarNumberBlock.vue?vue&type=script&lang=ts"
import style0 from "./CarNumberBlock.vue?vue&type=style&index=0&id=cfa76d9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfa76d9a",
  null
  
)

export default component.exports